// Third Party
import Coordinate from '@/types/coordinate';
import React from 'react';

type Props = {
  coordinates: Coordinate[];
};

const formatCoordinates = (coordinates: Coordinate[]) => coordinates.map(c => `${c.x},${c.y}`).join(' ');

const Line = ({ coordinates }: Props) => (
  <svg className="line">
    <polyline points={formatCoordinates(coordinates)} />
  </svg>
);

export default Line;
